import { fetch } from '@/shared/fetch';
import { IGetScheduleRequest, ITimeSlotDto } from '@/shared/interfaces';
import { startOfToday, addDays } from 'date-fns';
import { ConsultationTypeEnum } from '@/shared/enums';

export const fetchSchedule = async (
    consultationType: ConsultationTypeEnum,
    consultationDraftScheduledOn?: string,
): Promise<ITimeSlotDto[]> => {
    const startingDate = startOfToday();
    const endingDate = addDays(new Date(), 6);

    const request: IGetScheduleRequest = {
        FromDate: startingDate.toJSON(),
        ToDate: endingDate.toJSON(),
        ConsultationType: consultationType,
        ConsultationDraftScheduledOn: consultationDraftScheduledOn,
    };

    const query = Object.entries(request)
        .map(([key, value]) => `${key}=${encodeURIComponent(value ?? '')}`)
        .join('&');

    return await fetch<ITimeSlotDto[]>(
        '/api/consultations/video/schedule/v2?' + query,
        'GET',
    );
};
